//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';

import tableConfig from './tableConfig';

export default {
  data() {
    return {
      changingCurrencies: [],
      tableConfig,
      constant,
    };
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadDataAction(),
    ]);
    this.setGeneralLoader(false);
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('cryptomatsCurrencies', ['page', 'pages', 'filters', 'data']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsCurrencies', {
      loadDataAction: 'loadCurrencies',
      toggleCurrencyTradeabilityAction: 'toggleCurrencyTradeability',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },
    getButtonText(isEnabled, id) {
      const isChanging = this.changingCurrencies.includes(id);
      return (isEnabled && !isChanging) || (!isEnabled && isChanging)
        ? this.$t('const.Active button')
        : this.$t('const.Blocked button');
    },
    toggleCurrencyTradeability(index) {
      const currentIndex = this.changingCurrencies.indexOf(index);
      if (currentIndex === -1) {
        this.changingCurrencies.push(index);
      } else {
        this.changingCurrencies.splice(currentIndex, 1);
      }
    },
    async changeCurrenciesTradeability() {
      const promises = this.changingCurrencies.map((id) => this.toggleCurrencyTradeabilityAction(id));
      const res = await Promise.allSettled(promises);
      if (res.every((r) => r.status === 'fulfilled')) {
        await this.loadDataAction();
        this.changingCurrencies = [];
      }
    },
  },
};
